import React from "react";
import styles from "./MainButton.module.css";

const MainButton = ({ children, fontSize = '18px' }) => {
  return (
    <button className={styles.pushable}>
      <span className={styles.front} style={{ fontSize: fontSize }}>
        {children}
      </span>
    </button>
  );
};

export default MainButton;